import React, { Component } from "react";
import { Link } from "react-router-dom";
import { TEXT_LABELS } from "../common/configTable";
import MUIDataTable from "mui-datatables";
import { Tooltip, Typography } from "@material-ui/core";
import Active from "../common/active";
import ThemeContainer from "../common/ThemeProvider";

class GroupsTableI extends Component {
  render() {
    const { datas } = this.props;
    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: "excluded",
        },
      },
      {
        name: "code",
        label: "Código",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "acronym",
        label: "Siglas",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "name",
        label: "Nombre",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={`/grupoI/${tableMeta.rowData[0]}`}
              >
                {value}
              </Link>
            );
          },
        },
      },
      {
        name: "dependency.name",
        label: "Facultad",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "updated_at",
        label: "Fecha actualización",
        options: {
          filter: false,
          sort: false,
          display: "excluded",
        },
      },
      {
        name: "updated_at",
        label: "Última actualización",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Tooltip
                title={`${tableMeta.rowData[5]}`}
                style={{ cursor: "pointer" }}
              >
                <span>{`${value}`}</span>
              </Tooltip>
            );
          },
        },
      },
      {
        name: "active",
        label: "Estado",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return <Active actived={value} />;
          },
        },
      },
    ];
    const options = {
      filterType: "dropdown",
      responsive: "scroll",
      rowsPerPage: 20,
      rowsPerPageOptions: [5, 10, 20],
      // selectableRows:'none',
      textLabels: TEXT_LABELS,
      onRowsDelete: (rowsDeleted, newTableData) => {
        const items = datas; //lista de todos los proyectos
        const itemsToDelete = rowsDeleted.data.map(
          (item) => items[item.dataIndex]
        ); //Array de todos los proyectos a borrar.
        this.props.onDelete(itemsToDelete);
      },
    };

    return (
      <ThemeContainer>
        <MUIDataTable
          title={
            <Typography variant="h6">
              Lista de grupos de investigación
            </Typography>
          }
          data={datas}
          columns={columns}
          options={options}
        />
      </ThemeContainer>
    );
  }
}

export default GroupsTableI;
